function Asterisk() {
  return <span className="text-danger"> *</span>;
}

export default Asterisk;
